import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addTasksToJob } from '../api';
import type { AddTasksToJobInput } from '@maker-toolchest/shared';

export function useAddTasks(jobId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: AddTasksToJobInput) => addTasksToJob(jobId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
      queryClient.invalidateQueries({ queryKey: ['job', jobId] });
    },
  });
}
